import type { HTMLAttributes, ReactNode } from 'react';
import './components.css';

export type ChipTone = 'neutral' | 'accent' | 'outline' | 'warn' | 'danger' | 'struck' | 'invert';
export interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: ChipTone;
  dot?: string;
  children: ReactNode;
}
/** Chips de status: confirmado=accent, marcado=outline, atendido=neutral, faltou=danger, cancelado=struck, humano=warn. */
export function Chip({ tone = 'neutral', dot, className = '', children, ...rest }: ChipProps) {
  return (
    <span className={`k-chip k-chip--${tone} ${className}`} {...rest}>
      {dot && <span className="k-chip__dot" style={{ background: dot }} />}
      {children}
    </span>
  );
}
